import React, { memo } from "react";
import { Container, Row, Col } from "react-bootstrap";
import AccountingImg from "../../asset/Accounting.webp"; // Hero background
import LineImg from "../../asset/line1.png"; // Decorative line

import image2 from "../../asset/accountingservice.webp"; // Right-side image
import pointImg from "../../asset/point.png"; // Icon for points
import "./ServiceBusiness.css";

// ✅ Reusable point item component
const ServicePoint = memo(({ text }) => (
  <li>
    <img src={pointImg} alt="icon" className="point-icon" loading="lazy" />
    {text}
  </li>
));

const ServiceAccounting = () => {
  const servicePoints = [
    "Accounting System Design & Implementation",
    "IFRS Accounting",
    "Tally ERP Certification",
    "Budgeting & MIS Reports",
    "Financial Analysis - Ageing Reports, Variance Analysis",
    "Designing Accounting System for New Ventures",
    "Financial Reporting - P&L, Balance Sheet, Cash Flow Statements",
    "Financial Accounting - Transaction Entry, BRS, Ledger Maintenance",
    "Asset Accounting Management - Fixed Asset Register, Depreciation & Amortization",
  ];

  return (
    <div>
      {/* Hero Section */}
      <div className="services-hero"
        style={{
    backgroundImage: `url(${AccountingImg})`, // ✅ Use template literal with imported image
  }}
      >
        <div className="services-overlay"></div>
        <div className="services-content">
          <h1 className="services-heading">Building Trust Through Transparency</h1>
          <p className="services-paragraph">
            We deliver through audits and assurance services that enhance credibility,
            accuracy and confidence for your stakeholders.
          </p>
        </div>
      </div>

      {/* Accounting Image Section */}
      <div className="detail-section">
        <Container className="text-center">
          <div className="d-flex align-items-center justify-content-center flex-wrap">
            <img src={LineImg} alt="line-left" className="side-line" loading="lazy" />
            <div className="center-image-wrapper">
              {/* <img src={image1} alt="Accounting Service" className="side-image" loading="lazy" /> */}
              <div className="image-text">Accounting Services</div>
            </div>
            <img src={LineImg} alt="line-right" className="side-line mirrored" loading="lazy" />
          </div>
        </Container>
      </div>

      {/* Service Points Section */}
      <div className="service-image-section">
        <Container>
          <Row className="align-items-center">
            {/* Left Column with Points */}
            <Col md={6}>
              <ul className="service-points">
                {servicePoints.map((point, index) => (
                  <ServicePoint key={index} text={point} />
                ))}
              </ul>
            </Col>

            {/* Right Column with Image */}
            <Col md={6} className="text-center text-md-end">
              <img
                src={image2}
                alt="Service Detail"
                className="service-right-image"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default memo(ServiceAccounting);
